// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


let stripe_key = process.env.NEXT_PUBLIC_STRIPE_KEY;

let google_key = process.env.NEXT_PUBLIC_GOOGLE_KEY;

let attachment_prefix = process.env.NEXT_PUBLIC_ATTACHMENT_PREFIX;

let node_env = process.env.NODE_ENV;

let apiPath = process.env.NEXT_PUBLIC_API_PATH;

let graphqlWsHost = process.env.NEXT_PUBLIC_GRAPHQL_SUBSCRIPTIONS_WS_HOST;

let adminAppUrl = process.env.NEXT_PUBLIC_ADMIN_APP_URL;

exports.stripe_key = stripe_key;
exports.google_key = google_key;
exports.attachment_prefix = attachment_prefix;
exports.node_env = node_env;
exports.apiPath = apiPath;
exports.graphqlWsHost = graphqlWsHost;
exports.adminAppUrl = adminAppUrl;
/* stripe_key Not a pure module */
